<button [type]="type" class="button-container" (click)="clickHandler()" [disabled]="disabled">
  <i *ngIf="iconName" [class]="iconName"></i>
	<div *ngIf="captionToTranslate && captionToTranslate.length > 0" class="caption">{{captionToTranslate | cpActionTranslate: translationParameters | async}}</div>
</button>
